import { render, staticRenderFns } from "./MenuNutritionist.vue?vue&type=template&id=6c9b8354&"
import script from "./MenuNutritionist.vue?vue&type=script&lang=js&"
export * from "./MenuNutritionist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports